@if (vm$ | async; as vm) {
  <div>
    <div class="address-search" [class.address-search--desktop]="context === 'desktop'">
      <label class="address-search__label" for="address-search">{{ vm.label }}</label>
      <div class="address-search__search">
        @if (vm.searchTermControl) {
          <input
            class="address-search__input"
            id="address-search"
            type="text"
            [formControl]="vm.searchTermControl"
            [placeholder]="vm.placeholder"
            [attr.data-qa]="'address-search-input'"
            autocomplete="off"
            (keydown)="onKeyDown($event)"
            (keyup.enter)="$event.stopPropagation()"
            />
        }
      </div>
      @if (vm.showError) {
        <div>
          @if (vm.searchTermControl?.hasError('required')) {
            <app-address-form-error [message]="errorMessage"></app-address-form-error>
          }
        </div>
      }
    </div>
    @if (vm.searchResults$ | async; as vmResults) {
      @if (vmResults.length) {
        <div class="address-results">
          <div class="address-results__results" [class.address-results__results--desktop]="context === 'desktop'">
            @for (vmResult of vmResults; track vmResult; let i = $index) {
              <div
                class="address-results__result"
                [class.address-results__result--active]="i === presenter.selectedIndex"
                (click)="searchOrRetrieve(vmResult.id, vmResult.type)"
                [attr.data-qa]="'address-search-result'"
                #resultItem
                >
                {{ vmResult.description }}
              </div>
            }
          </div>
        </div>
      }
    }
    @if (vm.noResult$ | async) {
      <div class="address-results">
        <div class="address-results__results">
          <div class="address-results__result" [attr.data-qa]="'address-search-no-result'">{{ vm.noResultsFound }}</div>
        </div>
      </div>
    }
  </div>
}
